import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import { DialogContent, Grid } from "@material-ui/core";
import shippingMethodsService from "../../../services/shipping-methods.service";
import { useSelector } from "react-redux";

const initialValues = {
  name: "",
  description: "",
  url: "",
  type: null,
  isActive: true,
  addressRequired: true,
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  description: yupSchema.description,
  url: yupSchema.url,
});

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();
  const { initials } = useSelector((s) => s.app);

  const form = useMemo(
    () => [
      {
        _type: "textField",
        _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
        name: "name",
        label: "نام",
        autoFocus: true,
      },
      {
        _type: "autocomplete",
        _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
        _empty: undefined,
        name: "targetStatus",
        options:
          initials?.enums?.orderStatus.filter((s) =>
            ["awaitingCoordination", "awaitingFulfillment"].includes(s.value)
          ) || [],
        label: "وضعیت بعد پرداخت",
        valueSelector: "value",
        labelSelector: "title",
        disableClearable: true,
      },

      {
        _type: "textField",
        _wrapper: (props) => <Grid item xs={12} {...props} />,
        name: "description",
        multiline: true,
        rows: 4,
        label: "توضیحات",
      },
      {
        _type: "switch",
        _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
        name: "isActive",
        label: "فعال",
      },
      {
        _type: "switch",
        _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
        name: "addressRequired",
        label: "نیاز به آدرس",
      },
    ],
    [initials]
  );

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await shippingMethodsService.editShippingMethod(data.id, model);
    } else {
      op = await shippingMethodsService.createShippingMethod(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "روش ارسال",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
}
